import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetTransactionWaiverModel } from "@factory/model/query-model-transaction-waiver";
import { transactionWaiverFormDefault } from "./form.default";
import { TransactionWaiverFormSchema } from "./form.rule";

export const useFormDefaultTransactionWaiver = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetTransactionWaiverModel | undefined) => {
    return !cachedValue
      ? transactionWaiverFormDefault
     : ({
        batch: cachedValue.batch,
        waiver: cachedValue.waiver,
        signature: cachedValue.signature,
      } as TransactionWaiverFormSchema);
  };

  return {
    getDefault,
  };
};
